var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path, _g11, _g12, _g13, _g14, _path2, _path3, _path4, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path5, _path6, _path7, _g23, _g24, _g25, _g26, _g27, _g28, _path8, _path9, _path10, _path11, _path12, _path13, _g29, _g30, _g31, _g32, _g33, _g34, _path14, _path15, _path16, _g35, _g36, _path17, _path18, _path19, _g37, _g38, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadOfficeMeetingPhase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 840.33 1012.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .hom-disable-rect{\n        fill: #edeef0;\n      }\n      .hom-disable-rect:hover {\n        pointer-events: none;\n        fill: #edeef0;  \n      }\n      .cls-1-hom-p1 {\n        fill: #fff;\n      }\n\n      .cls-1-hom-p1, .cls-2-hom-p1, .cls-3-hom-p1, .cls-4-hom-p1 {\n        stroke: #1071e5;\n      }\n\n      .cls-2-hom-p1, .cls-3-hom-p1 {\n        fill: #1071e5;\n      }\n\n      .cls-3-hom-p1 {\n        stroke-width: .05px;\n      }\n\n      .cls-5-hom-p1 {\n        fill: #3a414a;\n        stroke-width: 0px;\n      }\n\n      .cls-4-hom-p1 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rect1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M243.54,6.5c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H249.53c-3.31,0-6-2.69-6-6V6.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I",
    className: "cls-5-hom-p1",
    d: "M281.68,47.96c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J",
    className: "cls-5-hom-p1",
    d: "M291.66,46.94c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM291.6,58.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    className: "cls-5-hom-p1",
    d: "M312.71,48.64c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L",
    className: "cls-5-hom-p1",
    d: "M326.57,46.94c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM326.02,58.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    className: "cls-5-hom-p1",
    d: "M333.97,60.12v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    className: "cls-5-hom-p1",
    d: "M344.49,46.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM348.02,52.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    className: "cls-5-hom-p1",
    d: "M355.29,56.92c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-2",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M364.86,46.94c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM368.39,52.44c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P",
    className: "cls-5-hom-p1",
    d: "M387.06,45.18v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    className: "cls-5-hom-p1",
    d: "M395.35,60.12v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    className: "cls-5-hom-p1",
    d: "M407.98,54.55v-1.9h5.98v1.9h-5.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    className: "cls-5-hom-p1",
    d: "M431.27,60.12l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    className: "cls-5-hom-p1",
    d: "M444.85,57.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM438.53,56.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-2",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M456.66,46.94c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM456.12,58.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-2",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M478.8,57.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM472.48,56.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-3",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M490.61,46.94c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM490.07,58.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-4",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M504.19,46.94c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM503.65,58.76c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    className: "cls-5-hom-p1",
    d: "M517.71,49.05c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-2",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M524.84,46.94c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM524.77,58.76c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V",
    className: "cls-5-hom-p1",
    d: "M538.96,60.12h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-3",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M553.42,57.67c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM547.11,56.52c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-2",
    "data-name": "M",
    className: "cls-5-hom-p1",
    d: "M559.06,60.12v-17.72h2.17v17.72h-2.17"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "rect3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M244.9,360.25c0-3.31,2.69-6,6-6h330.27c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H250.9c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    id: "W",
    className: "cls-5-hom-p1",
    d: "M306.82,389.09c-.07,2.78-1.56,4.35-4.07,4.75l4.75,7.27h-2.58l-4.41-6.99h-5.23v6.99h-2.24v-16.84c5.98.2,13.92-1.43,13.78,4.82ZM295.28,392.35c4.07-.14,9.3.88,9.3-3.19s-5.43-2.85-9.3-3.06v6.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-3",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M315.38,387.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM318.91,393.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X",
    className: "cls-5-hom-p1",
    d: "M334.19,388.2c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM328.55,399.61c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    className: "cls-5-hom-p1",
    d: "M337.38,385.42v-2.04h2.17v2.04h-2.17ZM337.38,401.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z",
    className: "cls-5-hom-p1",
    d: "M350.28,391.4c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-2",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M357.34,397.91c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-4",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M366.91,387.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM370.44,393.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-2",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M381.44,390.04c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    id: "O-3",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M392.58,397.91c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    className: "cls-5-hom-p1",
    d: "M402.56,389.63c-4.89,0-2.99,6.93-3.33,11.48h-2.17v-17.72h2.17l-.07,6.99c.81-1.43,1.9-2.44,4.14-2.44,6.04,0,3.6,7.88,4.07,13.17h-2.17v-8.22c.14-2.17-.54-3.33-2.65-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-5",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M415.73,387.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM419.27,393.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "K-2",
    "data-name": "K",
    className: "cls-5-hom-p1",
    d: "M443.57,389.63c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-6",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M456.41,387.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM459.94,393.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-7",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M469.99,387.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM473.52,393.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-4",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M480.78,397.91c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-2",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M485.2,385.42v-2.04h2.17v2.04h-2.17ZM485.2,401.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab",
    className: "cls-5-hom-p1",
    d: "M496.88,387.93c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-2",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M514.53,388.2c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM508.9,399.61c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Y-3",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M524.51,385.42v-2.04h2.17v2.04h-2.17ZM524.51,401.11v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-2",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M536.19,387.93c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "S-2",
    "data-name": "S",
    className: "cls-5-hom-p1",
    d: "M388.68,430.44l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-8",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M399.47,417.27c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM403,422.77c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-3",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M414,419.37c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    className: "cls-5-hom-p1",
    d: "M420.86,418.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad",
    className: "cls-5-hom-p1",
    d: "M432.27,430.71c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-4",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M447.89,419.37c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    className: "cls-5-hom-p1",
    d: "M460.38,417.54l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hom-disable-rect",
    d: "M.5,554.78c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af",
    className: "cls-5-hom-p1",
    d: "M27.06,608.4v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    className: "cls-5-hom-p1",
    d: "M37.39,595.23c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM38,596.86c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-9",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M51.98,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM55.52,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-3",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M66.72,595.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-5",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M76.36,605.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-4",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M80.77,592.72v-2.04h2.17v2.04h-2.17ZM80.77,608.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah",
    className: "cls-5-hom-p1",
    d: "M91.37,592.51c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae-2",
    "data-name": "ae",
    className: "cls-5-hom-p1",
    d: "M103.45,595.5l-5.84,15.01c-.95,1.9-2.51,3.46-5.5,2.85v-1.63c2.65.41,3.6-1.36,4.35-3.4l-5.09-12.83h2.31l3.87,10.59,3.67-10.59h2.24"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ai",
    className: "cls-5-hom-p1",
    d: "M126.2,608.27c-1.9.68-4.21,0-5.23-1.22-2.72,2.65-10.12,2.17-9.78-3.06.2-2.92,1.97-4.14,4.07-5.16-1.7-2.72-1.15-7.74,3.19-7.33,2.38.2,4.01,1.02,4.01,3.4,0,2.99-2.72,3.6-4.82,4.69.95,1.77,2.17,3.4,3.46,4.89.95-1.43,1.63-2.92,2.04-4.89l1.77.54c-.61,2.24-1.43,3.87-2.58,5.57.88.88,2.24,1.49,3.87,1.02v1.56ZM116.9,598.15c1.7-.68,3.53-1.22,3.8-3.26-.07-1.22-.88-1.97-2.24-1.97-2.85,0-2.65,3.4-1.56,5.23ZM113.16,603.92c-.2,3.46,4.82,3.94,6.65,1.9-1.36-1.63-2.78-3.46-3.8-5.43-1.56.68-2.72,1.63-2.85,3.53"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ac-2",
    "data-name": "ac",
    className: "cls-5-hom-p1",
    d: "M139.92,596.93c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-3",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M152.41,595.23c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM152.34,607.04c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-4",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M167.15,595.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-2",
    "data-name": "ah",
    className: "cls-5-hom-p1",
    d: "M179.64,592.51c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-5",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M181.2,592.72v-2.04h2.17v2.04h-2.17ZM181.2,608.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-5",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M192.68,597.33c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-3",
    "data-name": "K",
    className: "cls-5-hom-p1",
    d: "M207.27,596.93c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-2",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M229.27,598.69c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-5",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M240.14,595.23c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM239.6,607.04c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-10",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M252.7,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM256.23,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-4",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M269.06,605.96c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM262.75,604.8c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj",
    className: "cls-5-hom-p1",
    d: "M282.78,608.4l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-11",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M292.08,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM295.61,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-6",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M306.61,597.33c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-3",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M316.12,598.69c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M243.9,410.25h-72.27v121.65"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M244.4,410.75h-.5v-1h.5v1Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M171.63,546.67l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "rect4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M497.17,554.78c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    id: "af-2",
    "data-name": "af",
    className: "cls-5-hom-p1",
    d: "M547.46,608.4v-16.84h2.31v16.84h-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-5",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M559.96,595.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-6",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M567.22,592.72v-2.04h2.17v2.04h-2.17ZM567.22,608.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-6",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M574.96,605.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-7",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M579.38,592.72v-2.04h2.17v2.04h-2.17ZM579.38,608.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-5",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M592.69,605.96c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM586.37,604.8c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-7",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M600.7,605.21c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-12",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M610.27,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM613.8,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ak",
    className: "cls-5-hom-p1",
    d: "M633.15,608.4h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-13",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M645.58,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM649.11,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-6",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M660.31,595.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-2",
    "data-name": "ad",
    className: "cls-5-hom-p1",
    d: "M671.65,608.67c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-14",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M686.32,595.23c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM689.85,600.73c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Z-4",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M709.07,598.69c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-4",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M718.91,595.23c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM718.85,607.04c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-3",
    "data-name": "ad",
    className: "cls-5-hom-p1",
    d: "M731.41,608.67c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-7",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M747.02,597.33c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-3",
    "data-name": "ac",
    className: "cls-5-hom-p1",
    d: "M753.88,596.93c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-8",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M761.22,592.72v-2.04h2.17v2.04h-2.17ZM761.22,608.4v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-7",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M772.9,595.23c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-3",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M790.55,595.5c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM784.91,606.91c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "rect7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M.5,730.25c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6h0v-100Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "a-2",
    "data-name": "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-2",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M85.36,758.95c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-5",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M95.34,757.93c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM95.27,769.75c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-4",
    "data-name": "K",
    className: "cls-5-hom-p1",
    d: "M116.39,759.63c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-6",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M130.24,757.93c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM129.7,769.75c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-3",
    "data-name": "M",
    className: "cls-5-hom-p1",
    d: "M137.64,771.11v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-15",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M148.17,757.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM151.7,763.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-8",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M158.96,767.91c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-16",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M168.54,757.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM172.07,763.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al",
    className: "cls-5-hom-p1",
    d: "M194.68,758.27c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-7",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M206.22,757.93c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM205.68,769.75c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-17",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M218.78,757.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM222.31,763.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-6",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M235.15,768.66c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM228.83,767.51c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-2",
    "data-name": "aj",
    className: "cls-5-hom-p1",
    d: "M248.86,771.11l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-18",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M258.17,757.93c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM261.7,763.43c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-8",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M272.7,760.04c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-3",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M124.03,788.29c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-6",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M134.01,787.27c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM133.94,799.08c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-8",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M148.74,787.27c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-9",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M158.39,797.25c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-9",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M168.91,789.37c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-7",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M178.82,797.99c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM172.51,796.84c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac-4",
    "data-name": "ac",
    className: "cls-5-hom-p1",
    d: "M189.35,788.96c-2.72,0-3.26,2.24-3.26,4.96s.61,5.09,3.26,5.09c1.63,0,2.78-.95,2.92-2.58l2.17.14c-.41,2.51-2.1,4.14-5.02,4.14-4.01,0-5.16-2.78-5.57-6.72-.68-6.31,6.86-8.9,9.98-4.35.27.48.34.95.48,1.49l-2.17.2c-.27-1.43-1.09-2.38-2.78-2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-10",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M199.06,797.25c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-9",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M203.47,784.75v-2.04h2.17v2.04h-2.17ZM203.47,800.44v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-9",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M215.15,787.27c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-4",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M232.81,787.54c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM227.17,798.95c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M171.63,837.25v45.56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M172.13,837.25h-1v-.5h1v.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M171.63,897.57l-4.64-14.26h9.26l-4.62,14.26Z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "rect8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M.5,905.69c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H6.5c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al-2",
    "data-name": "al",
    className: "cls-5-hom-p1",
    d: "M21.77,933.73c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-8",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M33.31,933.39c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM32.77,945.2c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-19",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M45.87,933.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM49.4,938.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-8",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M62.24,944.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM55.92,942.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-3",
    "data-name": "aj",
    className: "cls-5-hom-p1",
    d: "M75.95,946.56l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-20",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M85.26,933.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM88.79,938.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-10",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M99.79,935.49c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    id: "am",
    className: "cls-5-hom-p1",
    d: "M117.78,937.66c2.38.34,4.14,1.56,4.14,4.14,0,5.91-7.2,4.62-12.97,4.75v-16.84c5.16.2,12.02-1.15,12.02,4.07,0,2.24-1.29,3.4-3.19,3.87ZM111.19,936.92c3.4-.07,7.47.61,7.47-2.85,0-3.19-4.28-2.44-7.47-2.51v5.36ZM111.19,944.73c3.73-.14,8.42.95,8.42-3.06s-4.75-2.85-8.42-2.99v6.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-11",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M130.95,935.49c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-10",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M132.92,930.87v-2.04h2.17v2.04h-2.17ZM132.92,946.56v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-21",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M143.45,933.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM146.98,938.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-3",
    "data-name": "ah",
    className: "cls-5-hom-p1",
    d: "M157.1,930.67c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-11",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M158.66,930.87v-2.04h2.17v2.04h-2.17ZM158.66,946.56v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-10",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M170.34,933.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-5",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M187.99,933.66c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM182.35,945.07c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-9",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M205.92,944.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM199.6,942.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-11",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M217.87,933.39c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-2",
    "data-name": "ag",
    className: "cls-5-hom-p1",
    d: "M229.27,933.39c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM229.89,935.02c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "p-2",
    "data-name": "p"
  }, /*#__PURE__*/React.createElement("path", {
    id: "al-3",
    "data-name": "al",
    className: "cls-5-hom-p1",
    d: "M256.44,933.73c-.34-3.26-8.35-3.67-8.42.14.95,5.09,10.73.95,11.07,8.08.2,5.3-8.22,5.91-11.88,3.73-1.15-.68-1.9-1.77-2.24-3.12l2.24-.48c.34,3.8,9.57,4.28,9.57-.07,0-5.3-10.52-.95-11-8.01-.34-5.57,9.85-5.7,12.15-2.31.34.48.54,1.09.75,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-9",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M267.98,933.39c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM267.44,945.2c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-22",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M280.54,933.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM284.07,938.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-10",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M296.9,944.12c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM290.59,942.96c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aj-4",
    "data-name": "aj",
    className: "cls-5-hom-p1",
    d: "M310.62,946.56l-4.35-5.91-1.56,1.29v4.62h-2.17v-17.72h2.17v11.07l5.64-6.25h2.51l-5.23,5.57,5.57,7.33h-2.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-23",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M319.92,933.39c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM323.45,938.89c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-12",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M334.45,935.49c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    id: "P-2",
    "data-name": "P",
    className: "cls-5-hom-p1",
    d: "M137.06,960.95v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-13",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M150.17,964.83c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-11",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M160.08,973.45c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM153.77,972.29c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-12",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M165.72,960.21v-2.04h2.17v2.04h-2.17ZM165.72,975.89v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-12",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M177.4,962.72c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-13",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M184.66,960.21v-2.04h2.17v2.04h-2.17ZM184.66,975.89v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-13",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M196.34,962.72c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-6",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M214,962.99c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM208.36,974.4c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M171.63,661.78v45.57"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M172.13,661.8h-1v-.52h1v.52Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M171.63,722.12l-4.64-14.27h9.26l-4.62,14.27Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M668.3,661.78l.3,45.57"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M668.8,661.79h-1v-.5h1v.5Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M668.7,722.12l-4.73-14.24,9.27-.06-4.54,14.3Z"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "rect5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M497.58,730.25c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6h0v-100Z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Q-2",
    "data-name": "Q",
    className: "cls-5-hom-p1",
    d: "M554.8,769.54v-16.84h2.24v15.01h8.49v1.83h-10.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-3",
    "data-name": "S",
    className: "cls-5-hom-p1",
    d: "M582.64,769.54l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I-4",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M601.04,757.39c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-5",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M625.42,757.39c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-14",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M636.35,758.48c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-24",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M643.48,756.37c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM647.01,761.87c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-12",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M659.85,767.1c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM653.53,765.94c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-11",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M667.86,766.35c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-25",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M677.43,756.37c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM680.96,761.87c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-5",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M693.39,759.83c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-6",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M717.63,757.39c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-2",
    "data-name": "ak",
    className: "cls-5-hom-p1",
    d: "M730.12,769.54h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an",
    className: "cls-5-hom-p1",
    d: "M739.15,769.54v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    className: "cls-5-hom-p1",
    d: "M766.32,769.54l-8.96-14.33.07,14.33h-1.97v-16.84h2.65l9.03,14.46-.14-14.46h2.1v16.84h-2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-3",
    "data-name": "P",
    className: "cls-5-hom-p1",
    d: "M779.62,754.61v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U-15",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M588.75,787.81c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-26",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M595.88,785.7c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM599.41,791.2c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-7",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M614.69,785.98c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM609.06,797.38c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-14",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M617.88,783.19v-2.04h2.17v2.04h-2.17ZM617.88,798.88v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-6",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M630.78,789.17c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-12",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M637.85,795.69c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-16",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M648.37,787.81c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-13",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M658.28,796.43c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM651.97,795.28c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-13",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M666.3,795.69c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-15",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M670.71,783.19v-2.04h2.17v2.04h-2.17ZM670.71,798.88v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-7",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M681.23,785.7c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM681.17,797.52c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-14",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M695.97,785.7c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ah-4",
    "data-name": "ah",
    className: "cls-5-hom-p1",
    d: "M715.25,782.99c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-8",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M721.98,785.7c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM721.91,797.52c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-17",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M736.51,787.81c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K-5",
    "data-name": "K",
    className: "cls-5-hom-p1",
    d: "M751.11,787.4c-4.55.2-2.58,7.13-2.99,11.48h-2.1v-8.22c0-1.97-.34-3.4-2.38-3.26-4.48.27-2.58,7.06-2.99,11.48h-2.1l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.68-2.99,6.72-3.4,7.27,0,.75-1.43,1.83-2.38,3.94-2.44,5.77-.14,3.19,8.08,3.73,13.17h-2.1v-8.22c0-1.97-.34-3.33-2.38-3.26"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M668.7,837.25l-.3,45.56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M669.2,837.25h-1v-.5h1v.5Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M668.3,897.57l-4.54-14.3,9.27.07-4.73,14.23Z"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "rect6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M497.17,905.69c0-3.31,2.69-6,6-6h330.25c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6h-330.25c-3.31,0-6-2.69-6-6v-100Z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ak-3",
    "data-name": "ak",
    className: "cls-5-hom-p1",
    d: "M532.22,961.5h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak-4",
    "data-name": "ak",
    className: "cls-5-hom-p1",
    d: "M548.52,961.5h-2.31l-6.86-16.84h2.38l5.64,14.8,5.64-14.8h2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ap",
    className: "cls-5-hom-p1",
    d: "M557.55,944.66c5.91.07,12.97-1.02,12.97,5.09,0,5.3-5.23,5.43-10.73,5.16v6.59h-2.24v-16.84ZM559.79,953.15c3.87,0,8.42.75,8.42-3.4s-4.62-3.19-8.42-3.26v6.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S-4",
    "data-name": "S",
    className: "cls-5-hom-p1",
    d: "M588.1,961.5l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "T-14",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M608.47,959.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM602.16,957.9c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-10",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M620.29,948.32c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM619.74,960.14c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L-11",
    "data-name": "L",
    className: "cls-5-hom-p1",
    d: "M633.87,948.32c3.73.07,4.75,2.78,4.75,6.65s-1.09,6.65-4.75,6.79c-2.1,0-3.33-.88-4.07-2.31l.07,7.13h-2.17l-.07-17.99h2.1l.14,2.04c.68-1.43,1.9-2.31,4.01-2.31ZM633.32,960.14c2.72,0,3.06-2.31,3.06-5.09s-.41-4.96-3.06-5.02c-2.85,0-3.46,2.17-3.46,5.16s.68,4.96,3.46,4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-18",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M647.38,950.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "J-9",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M654.51,948.32c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM654.44,960.14c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "V-2",
    "data-name": "V",
    className: "cls-5-hom-p1",
    d: "M668.63,961.5h-2.58l-4.69-12.9h2.31l3.67,11.2,3.8-11.2h2.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-15",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M683.1,959.05c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM676.78,957.9c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-4",
    "data-name": "M",
    className: "cls-5-hom-p1",
    d: "M688.73,961.5v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    className: "cls-5-hom-p1",
    d: "M697.08,958.92c.07,2.31,0,4.41-.95,5.7h-1.49c.61-.88,1.15-1.77,1.15-3.12h-1.09v-2.58h2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Y-16",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M707.68,945.81v-2.04h2.17v2.04h-2.17ZM707.68,961.5v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ah-5",
    "data-name": "ah",
    className: "cls-5-hom-p1",
    d: "M718.27,945.61c-2.1-.61-2.85.68-2.58,2.99h2.58v1.56h-2.58v11.34h-2.1v-11.34h-1.83v-1.56h1.83c-.48-3.53,1.15-5.57,4.69-4.62v1.63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "D"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U-19",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M732.73,950.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-27",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M739.86,948.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM743.39,953.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ar",
    className: "cls-5-hom-p1",
    d: "M756.5,959.39c-.75,1.49-1.97,2.38-4.07,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.01,1.15-6.72,4.75-6.79,2.17-.07,3.26.95,4.07,2.24,0-.75-.07-1.63.14-2.17h2.04l-.07,18.2h-2.17l.07-7.2ZM752.97,960.07c2.78,0,3.46-2.24,3.46-5.16s-.54-4.96-3.4-4.96-3.12,2.38-3.12,5.09.34,5.02,3.06,5.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ad-4",
    "data-name": "ad",
    className: "cls-5-hom-p1",
    d: "M765.94,961.77c-6.04.27-3.67-7.88-4.14-13.17h2.17v8.15c0,2.1.48,3.4,2.65,3.33,4.89-.14,3.06-6.86,3.4-11.48h2.1l.07,12.9h-2.04c-.07-.68.07-1.7-.14-2.24-.75,1.49-1.9,2.44-4.07,2.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-17",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M775.44,945.81v-2.04h2.17v2.04h-2.17ZM775.44,961.5v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U-20",
    "data-name": "U",
    className: "cls-5-hom-p1",
    d: "M786.92,950.43c-5.3-1.09-3.6,6.18-3.87,11.07h-2.17l-.07-12.9h2.04c.07.81-.07,1.97.14,2.65.41-1.83,1.56-3.33,3.94-2.78v1.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-28",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M794.05,948.32c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM797.58,953.82c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag-3",
    "data-name": "ag",
    className: "cls-5-hom-p1",
    d: "M806.61,948.32c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM807.22,949.95c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M414.67,113.5v46.98"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M415.17,113.51h-1v-.5h1v.5Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M414.67,175.25l-4.64-14.27h9.27l-4.63,14.27Z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "rect2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-hom-p1",
    d: "M243.54,183.37c0-3.31,2.69-6,6-6h330.26c3.31,0,6,2.69,6,6v100c0,3.31-2.69,6-6,6H249.53c-3.31,0-6-2.69-6-6h0v-100Z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "E"
  }, /*#__PURE__*/React.createElement("path", {
    id: "S-5",
    "data-name": "S",
    className: "cls-5-hom-p1",
    d: "M304.57,236.99l.14-14.8c-1.56,5.16-3.67,9.85-5.43,14.8h-1.56l-5.5-14.8.07,14.8h-1.97v-16.84h2.99l5.23,14.33c1.43-5.09,3.46-9.51,5.16-14.33h2.92v16.84h-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-29",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M315.36,223.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM318.89,229.31c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-30",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M328.94,223.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM332.47,229.31c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-14",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M339.74,233.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-18",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M344.15,221.3v-2.04h2.17v2.04h-2.17ZM344.15,236.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-15",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M355.83,223.81c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "X-8",
    "data-name": "X",
    className: "cls-5-hom-p1",
    d: "M373.48,224.08c-.68,8.49,2.78,19.9-7.47,17.72-1.56-.41-2.58-1.36-2.99-2.92l2.17-.34c1.02,3.19,6.79,2.17,6.04-1.9v-2.04c-.75,1.43-1.97,2.44-4.14,2.44-3.67,0-4.62-2.78-4.62-6.52s1.09-6.59,4.82-6.65c1.97-.07,3.26,1.09,4.01,2.38.07-.68,0-1.56.14-2.17h2.04ZM367.85,235.49c2.44,0,3.4-2.17,3.4-4.96s-.95-5.09-3.4-5.09c-2.65,0-3.12,2.31-3.12,5.09s.41,4.96,3.12,4.96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ag-4",
    "data-name": "ag",
    className: "cls-5-hom-p1",
    d: "M387.61,223.81c2.1,0,3.26.88,4.07,2.24l-.07-6.79h2.17l.07,17.72h-2.04c-.14-.68,0-1.56-.2-2.1-.68,1.56-1.9,2.38-4.01,2.38-3.6,0-4.69-2.65-4.75-6.65,0-4.48,1.56-6.79,4.75-6.79ZM388.22,225.44c-2.72,0-3.12,2.31-3.12,5.09s.41,5.02,3.06,5.02c2.85,0,3.46-2.17,3.46-5.16s-.61-5.02-3.4-4.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "N-31",
    "data-name": "N",
    className: "cls-5-hom-p1",
    d: "M402.21,223.81c4.28,0,5.84,2.85,5.7,7.2h-9.17c0,2.72.95,4.55,3.6,4.62,1.77.07,2.92-.81,3.33-1.97l1.9.54c-.75,1.9-2.51,3.06-5.23,3.06-3.94,0-5.98-2.51-5.91-6.79.07-4.14,1.77-6.65,5.77-6.65ZM405.74,229.31c.41-4.07-5.16-5.23-6.59-1.9-.2.48-.41,1.15-.41,1.9h6.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O-15",
    "data-name": "O",
    className: "cls-5-hom-p1",
    d: "M413,233.79c-.14,1.63,1.22,1.97,2.58,1.49v1.63c-2.24.68-4.75.34-4.75-2.65v-8.62h-1.49v-1.56h1.63l.61-2.92h1.43v2.92h2.38v1.56h-2.38v8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "T-16",
    "data-name": "T",
    className: "cls-5-hom-p1",
    d: "M425.36,234.54c-1.02,1.43-2.1,2.78-4.62,2.72-2.44-.07-3.94-1.43-3.94-3.87-.07-4.35,4.28-4.28,8.49-4.28.2-2.38-.61-3.67-2.78-3.67-1.63.07-2.78.48-2.85,2.1l-2.24-.2c.34-2.51,2.24-3.53,5.16-3.53s4.89,1.36,4.89,4.35v5.57c-.07,1.36.48,2.17,1.9,1.83v1.36c-2.1.61-4.14-.14-4.01-2.38ZM419.05,233.39c0,1.36.81,2.24,2.17,2.24,2.78-.2,4.28-1.97,4.07-5.02-2.92.14-6.25-.34-6.25,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y-19",
    "data-name": "Y",
    className: "cls-5-hom-p1",
    d: "M431,221.3v-2.04h2.17v2.04h-2.17ZM431,236.99v-12.9h2.17v12.9h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M-5",
    "data-name": "M",
    className: "cls-5-hom-p1",
    d: "M436.36,236.99v-17.72h2.17v17.72h-2.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Z-7",
    "data-name": "Z",
    className: "cls-5-hom-p1",
    d: "M449.26,227.28c-.2-2.31-5.84-2.58-5.91,0,1.02,3.6,7.81.81,8.08,6.11s-10.19,5.02-10.66.54l1.9-.34c.27,2.44,6.59,3.06,6.65,0-.68-3.8-7.67-1.02-8.01-6.11-.27-3.87,5.57-4.28,8.28-2.85.81.48,1.43,1.29,1.63,2.38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("path", {
    id: "J-10",
    "data-name": "J",
    className: "cls-5-hom-p1",
    d: "M465.9,223.81c4.21-.07,5.77,2.51,5.77,6.72.07,4.28-1.83,6.72-5.84,6.72s-5.64-2.65-5.7-6.72c0-4.48,1.9-6.72,5.77-6.72ZM465.83,235.63c2.99.07,3.6-2.1,3.6-5.09s-.54-5.09-3.46-5.09-3.6,2.17-3.6,5.09.68,5.02,3.46,5.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ab-16",
    "data-name": "ab",
    className: "cls-5-hom-p1",
    d: "M480.63,223.81c6.04-.27,3.6,7.88,4.07,13.17h-2.17v-8.22c0-2.1-.54-3.33-2.65-3.26-4.89.14-2.99,6.93-3.33,11.48h-2.17l-.07-12.9h2.04c.07.68-.07,1.63.14,2.17.75-1.49,1.97-2.38,4.14-2.44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "H"
  }, /*#__PURE__*/React.createElement("path", {
    id: "I-7",
    "data-name": "I",
    className: "cls-5-hom-p1",
    d: "M507.45,224.83c-.68-1.9-2.38-3.06-4.96-3.06-4.01,0-5.91,2.72-5.91,6.72s1.97,6.86,6.04,6.86c2.92,0,4.21-1.63,5.3-3.53l1.83.95c-1.22,2.58-3.46,4.48-7.27,4.48-5.43,0-7.94-3.4-8.22-8.76-.41-7.06,6.72-10.39,12.7-7.54,1.29.61,2.1,1.77,2.65,3.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "an-2",
    "data-name": "an",
    className: "cls-5-hom-p1",
    d: "M512.68,236.99v-16.84h12.7v1.9h-10.46v5.36h9.78v1.83h-9.78v5.91h11v1.83h-13.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P-4",
    "data-name": "P",
    className: "cls-5-hom-p1",
    d: "M535.57,222.05v14.94h-2.31v-14.94h-5.77v-1.9h13.85v1.9h-5.77"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M414.68,290.37l1,47"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M415.18,290.37l-1,.02v-.52h1v.5Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M416,352.12l-4.93-14.17,9.27-.2-4.34,14.37Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4-hom-p1",
    d: "M588.17,410.25h80.12v121.65"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3-hom-p1",
    d: "M588.18,410.75h-.5v-1h.5v1Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2-hom-p1",
    d: "M668.3,546.67l-4.64-14.27h9.27l-4.63,14.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadOfficeMeetingPhase1);
export default __webpack_public_path__ + "static/media/Head_Office_Meeting_Phase_1.da874bae53bec39b31541bd7f5660962.svg";
export { ForwardRef as ReactComponent };